import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import { getFocusable } from '../helpers/focus';

function handleGuardFocus(event) {
  var currentTarget = event.currentTarget;
  var root = currentTarget.parentElement || currentTarget.parentNode;

  if (root instanceof HTMLDivElement) {
    var focusableList = getFocusable(root).filter(function (el) {
      return !el.hasAttribute('data-cactus-focus-guard');
    });

    if (focusableList.length) {
      var guardType = currentTarget.getAttribute('data-cactus-focus-guard'); // if the focused guard is at the start then well focus on that last item

      var index = guardType === 'start' ? focusableList.length - 1 : 0;
      var el = focusableList[index];
      if (el && el.focus) el.focus();
      event.stopPropagation();
      event.preventDefault();
    }
  }
}

export var FocusLock = /*#__PURE__*/React.forwardRef(function (props, forwardRef) {
  var children = props.children,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement("div", Object.assign({
    ref: forwardRef
  }, rest), /*#__PURE__*/React.createElement("div", {
    "data-cactus-focus-guard": "start",
    tabIndex: 0,
    onFocus: handleGuardFocus
  }), children, /*#__PURE__*/React.createElement("div", {
    "data-cactus-focus-guard": "end",
    tabIndex: 0,
    onFocus: handleGuardFocus
  }));
});
export default FocusLock;